module.exports = __webpack_public_path__ + "img/dior2.38d3ded7.jpg";